import { render, staticRenderFns } from "./tagLibrary.vue?vue&type=template&id=40a828e7"
import script from "./tagLibrary.vue?vue&type=script&lang=js"
export * from "./tagLibrary.vue?vue&type=script&lang=js"
import style0 from "./tagLibrary.vue?vue&type=style&index=0&id=40a828e7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports